package org.multipaz.utopia.generated

/**
 * Generated strings for language: ar
 * DO NOT EDIT - This file is auto-generated by the generateMultipazStrings task
 */
internal val strings_ar = mapOf(
    "boarding_pass_attribute_departure_time" to "وقت المغادرة",
    "boarding_pass_attribute_flight_number" to "رقم الرحلة",
    "boarding_pass_attribute_passenger_name" to "اسم الراكب",
    "boarding_pass_attribute_seat_number" to "رقم المقعد",
    "boarding_pass_description_departure_time" to "تاريخ ووقت المغادرة",
    "boarding_pass_description_flight_number" to "رقم الرحلة",
    "boarding_pass_description_passenger_name" to "اسم العائلة أو الكنية أو المعرّف الأساسي لحامل mDL.",
    "boarding_pass_description_seat_number" to "رقم المقعد",
    "cor_attribute_administrative_number" to "الرقم الإداري",
    "cor_attribute_date_of_arrival" to "تاريخ الوصول",
    "cor_attribute_date_of_birth" to "تاريخ الميلاد",
    "cor_attribute_date_of_expiry" to "تاريخ الانتهاء",
    "cor_attribute_date_of_issue" to "تاريخ الإصدار",
    "cor_attribute_document_number" to "رقم الوثيقة",
    "cor_attribute_family_name" to "اسم العائلة",
    "cor_attribute_gender" to "الجنس",
    "cor_attribute_given_names" to "الأسماء الأولى",
    "cor_attribute_issuing_authority" to "جهة الإصدار",
    "cor_attribute_issuing_country" to "بلد الإصدار",
    "cor_attribute_issuing_jurisdiction" to "سلطة الإصدار",
    "cor_attribute_nationality" to "الجنسية",
    "cor_attribute_older_than_18" to "أكبر من 18 عامًا",
    "cor_attribute_older_than_21" to "أكبر من 21",
    "cor_attribute_place_of_birth" to "مكان الميلاد",
    "cor_attribute_resident_address" to "عنوان الإقامة",
    "cor_attribute_resident_city" to "مدينة الإقامة",
    "cor_attribute_resident_country" to "بلد الإقامة",
    "cor_attribute_resident_house_number" to "رقم المنزل للإقامة",
    "cor_attribute_resident_postal_code" to "الرمز البريدي للإقامة",
    "cor_attribute_resident_state" to "ولاية الإقامة",
    "cor_attribute_resident_street" to "شارع الإقامة",
    "cor_description_administrative_number" to "رقم مُعيّن من قِبل مزود COR لأغراض مراقبة التدقيق أو لأغراض أخرى.",
    "cor_description_date_of_arrival" to "اليوم والشهر والسنة التي وصل فيها حامل شهادة التنسيق (COR) إلى الاتحاد الأوروبي.",
    "cor_description_date_of_birth" to "اليوم والشهر والسنة التي وُلِد فيها حامل شهادة التنسيق (COR). إذا كان غير معروف، فتاريخ الميلاد التقريبي.",
    "cor_description_date_of_expiry" to "تاريخ (وربما وقت) انتهاء صلاحية شهادة الإقامة.",
    "cor_description_date_of_issue" to "تاريخ (وربما وقت) إصدار شهادة الإقامة.",
    "cor_description_document_number" to "رقم لـ COR، مُعيّن من قِبل مزود COR.",
    "cor_description_family_name" to "اسم العائلة (أو اللقب) الحالي أو المعرّف الأساسي لحامل شهادة التنسيق (COR)",
    "cor_description_gender" to "جنس حامل شهادة الإقامة",
    "cor_description_given_names" to "الاسم (الأسماء) الأول الحالي، أو الأسماء الأخرى، أو المعرّف الثانوي لحامل شهادة التنسيق (COR)",
    "cor_description_issuing_authority" to "اسم السلطة الإدارية التي أصدرت هذا الإصدار من COR، أو رمز البلد ISO 3166 Alpha-2 للدولة العضو المعنية إذا لم تكن هناك سلطة منفصلة مخولة بإصدار CORs.",
    "cor_description_issuing_country" to "رمز البلد Alpha-2، كما هو محدد في ISO 3166-1، لبلد أو إقليم السلطة المصدرة",
    "cor_description_issuing_jurisdiction" to "رمز التقسيم الفرعي لبلد الولاية القضائية التي أصدرت COR، كما هو محدد في ISO 3166-2:2020، البند 8. يجب أن يكون الجزء الأول من الرمز مطابقًا لقيمة بلد الإصدار.",
    "cor_description_nationality" to "رمز الدولة المكون من حرفين (Alpha-2) كما هو محدد في ISO 3166-1، ويمثل جنسية المستخدم.",
    "cor_description_older_than_18" to "العمر أكثر من 18 عامًا؟",
    "cor_description_older_than_21" to "العمر أكثر من 21 عامًا؟",
    "cor_description_place_of_birth" to "المكان الذي وُلد فيه حامل شهادة الإقامة.",
    "cor_description_resident_address" to "العنوان الكامل للمكان الذي يقيم فيه حامل شهادة التنسيق (COR) حاليًا و/أو يمكن الاتصال به (رقم الشارع/المنزل، البلدية، إلخ.)",
    "cor_description_resident_city" to "المدينة التي يقيم بها حامل شهادة الإقامة حاليًا",
    "cor_description_resident_country" to "البلد الذي يقيم فيه المستخدم حاليًا، في شكل رمز البلد Alpha-2 كما هو محدد في ISO 3166-1",
    "cor_description_resident_house_number" to "رقم المنزل الذي يقيم به المستخدم حاليًا، بما في ذلك أي بادئة أو لاحقة",
    "cor_description_resident_postal_code" to "الرمز البريدي للمكان الذي يقيم به حامل شهادة الإقامة حاليًا",
    "cor_description_resident_state" to "الولاية أو المقاطعة أو المنطقة أو المنطقة المحلية التي يقيم بها المستخدم حاليًا.",
    "cor_description_resident_street" to "اسم الشارع الذي يقيم به المستخدم حاليًا.",
    "cor_request_age_over_18" to "العمر فوق 18",
    "cor_request_all_data_elements" to "جميع عناصر البيانات",
    "cor_request_mandatory_data_elements" to "عناصر البيانات الإلزامية",
    "document_display_name_boarding_pass" to "بطاقة الصعود",
    "document_display_name_certificate_of_residency" to "شهادة إقامة",
    "document_display_name_german_personal_id" to "بطاقة الهوية الألمانية",
    "document_display_name_loyalty_card" to "بطاقة ولاء",
    "document_display_name_movie_ticket" to "تذكرة سينما",
    "document_display_name_naturalization_certificate" to "شهادة التجنيس",
    "document_display_name_payment_card" to "بطاقة دفع",
    "german_id_attribute_administrative_number" to "الرقم الإداري",
    "german_id_attribute_age_in_years" to "العمر بالسنوات",
    "german_id_attribute_city_of_birth" to "مدينة الميلاد",
    "german_id_attribute_country_of_birth" to "بلد الميلاد",
    "german_id_attribute_date_of_birth" to "تاريخ الميلاد",
    "german_id_attribute_date_of_expiry" to "تاريخ الانتهاء",
    "german_id_attribute_date_of_issue" to "تاريخ الإصدار",
    "german_id_attribute_document_number" to "رقم الوثيقة",
    "german_id_attribute_family_name" to "اسم العائلة",
    "german_id_attribute_family_name_at_birth" to "اسم العائلة عند الولادة",
    "german_id_attribute_gender" to "الجنس",
    "german_id_attribute_given_names" to "الاسم الشخصي",
    "german_id_attribute_issuing_authority" to "الجهة المصدرة",
    "german_id_attribute_issuing_country" to "دولة الإصدار",
    "german_id_attribute_issuing_jurisdiction" to "جهة الإصدار",
    "german_id_attribute_nationality" to "الجنسية",
    "german_id_attribute_older_than_12" to "أكبر من 12 عامًا",
    "german_id_attribute_older_than_14" to "أكبر من 14 عامًا",
    "german_id_attribute_older_than_16" to "أكبر من 16",
    "german_id_attribute_older_than_18" to "أكبر من 18",
    "german_id_attribute_older_than_21" to "أكبر من 21",
    "german_id_attribute_older_than_65" to "أكبر من 65",
    "german_id_attribute_place_of_birth" to "مكان الميلاد",
    "german_id_attribute_resident_address" to "عنوان الإقامة",
    "german_id_attribute_resident_city" to "مدينة الإقامة",
    "german_id_attribute_resident_country" to "بلد الإقامة",
    "german_id_attribute_resident_postal_code" to "الرمز البريدي للإقامة",
    "german_id_attribute_state_of_birth" to "ولاية الميلاد",
    "german_id_attribute_year_of_birth" to "سنة الميلاد",
    "german_id_description_administrative_number" to "رقم مخصص من قبل مزود PID لأغراض التدقيق أو غيرها.",
    "german_id_description_age_in_years" to "عمر حامل الهوية بالسنوات",
    "german_id_description_city_of_birth" to "البلدية أو المدينة أو البلدة أو القرية التي وُلد فيها مستخدم PID",
    "german_id_description_country_of_birth" to "البلد الذي وُلد فيه مستخدم الهوية، كرمز بلد ألفا-2 كما هو محدد في ISO 3166-1",
    "german_id_description_date_of_birth" to "اليوم والشهر والسنة التي وُلد فيها حامل الهوية. إذا كان غير معروف، تاريخ الميلاد التقريبي",
    "german_id_description_date_of_expiry" to "تاريخ (وربما وقت) انتهاء صلاحية PID.",
    "german_id_description_date_of_issue" to "تاريخ (وربما وقت) إصدار PID.",
    "german_id_description_document_number" to "رقم لـ PID، مخصص من قبل مزود PID.",
    "german_id_description_family_name" to "اسم العائلة (الأسماء) الحالي، أو اللقب (الألقاب)، أو المعرّف الأساسي لحامل الهوية",
    "german_id_description_family_name_at_birth" to "اسم (أسماء) العائلة، أو اللقب (الألقاب)، أو المعرّف الأساسي لحامل وثيقة الهوية عند الولادة",
    "german_id_description_gender" to "جنس حامل PID",
    "german_id_description_given_names" to "الاسم الأول (الأسماء) الحالي، أو الأسماء الأخرى، أو المعرّف الثانوي لحامل الهوية",
    "german_id_description_issuing_authority" to "اسم الجهة الإدارية التي أصدرت هذا الـ PID، أو رمز الدولة الأبجدي الثنائي (Alpha-2) وفق ISO 3166 للدولة العضو المعنية إذا لم تكن هناك جهة منفصلة مصرح لها بإصدار الـ PIDs.",
    "german_id_description_issuing_country" to "رمز الدولة ألفا-2، كما هو محدد في ISO 3166-1، لبلد أو إقليم الجهة المصدرة.",
    "german_id_description_issuing_jurisdiction" to "رمز التقسيم الفرعي للبلد للولاية القضائية التي أصدرت الـ PID، كما هو محدد في ISO 3166-2:2020، البند 8. يجب أن يكون الجزء الأول من الرمز مطابقًا لقيمة issuing_country.",
    "german_id_description_nationality" to "قائمة برموز الدول الأبجدية الثنائية (Alpha-2) كما هو محدد في ISO 3166-1، والتي تمثل جنسية مستخدم PID.",
    "german_id_description_older_than_12" to "العمر أكثر من 12 عامًا؟",
    "german_id_description_older_than_14" to "العمر أكثر من 14 عامًا؟",
    "german_id_description_older_than_16" to "العمر أكثر من 16 عامًا؟",
    "german_id_description_older_than_18" to "العمر أكثر من 18 عامًا؟",
    "german_id_description_older_than_21" to "العمر أكثر من 21 عامًا؟",
    "german_id_description_older_than_65" to "العمر أكثر من 65 عامًا؟",
    "german_id_description_place_of_birth" to "البلد والبلدية أو الولاية/المقاطعة التي وُلد فيها حامل وثيقة الهوية",
    "german_id_description_resident_address" to "العنوان الكامل للمكان الذي يقيم فيه حامل PID حاليًا و/أو يمكن التواصل معه فيه (رقم الشارع/المنزل، البلدية وما إلى ذلك)",
    "german_id_description_resident_city" to "المدينة التي يقيم فيها حامل PID حاليًا",
    "german_id_description_resident_country" to "البلد الذي يقيم فيه مستخدم PID حاليًا، برمز دولة أبجدي ثنائي (Alpha-2) كما هو محدد في ISO 3166-1",
    "german_id_description_resident_postal_code" to "الرمز البريدي للمكان الذي يقيم فيه حامل PID حاليًا",
    "german_id_description_state_of_birth" to "الولاية أو المقاطعة أو المنطقة أو المنطقة المحلية التي وُلد فيها مستخدم الهوية",
    "german_id_description_year_of_birth" to "السنة التي وُلد فيها حامل الهوية",
    "german_id_request_age_over_18" to "أكبر من 18 عامًا",
    "german_id_request_all_data_elements" to "جميع عناصر البيانات",
    "german_id_request_mandatory_data_elements" to "عناصر البيانات الإلزامية",
    "loyalty_attribute_date_of_expiry" to "تاريخ الانتهاء",
    "loyalty_attribute_date_of_issue" to "تاريخ الإصدار",
    "loyalty_attribute_family_name" to "اسم العائلة",
    "loyalty_attribute_given_names" to "الأسماء الأولى",
    "loyalty_attribute_membership_id" to "رقم العضوية",
    "loyalty_attribute_photo_of_holder" to "صورة الحامل",
    "loyalty_attribute_tier" to "الفئة",
    "loyalty_description_date_of_expiry" to "تاريخ انتهاء الصلاحية",
    "loyalty_description_date_of_issue" to "تاريخ الإصدار",
    "loyalty_description_family_name" to "الاسم الأخير أو اسم العائلة أو المعرّف الأساسي لحامل المستند",
    "loyalty_description_given_names" to "الاسم الأول (الأسماء الأولى) أو الأسماء الأخرى أو المعرّف الثانوي لحامل المستند",
    "loyalty_description_membership_id" to "المعرّف الشخصي لحامل هوية الولاء.",
    "loyalty_description_photo_of_holder" to "نسخة من صورة حامل المستند الشخصية.",
    "loyalty_description_tier" to "فئة العضوية (أساسية، فضية، ذهبية، بلاتينية، نخبة)",
    "loyalty_request_all_data_elements" to "جميع عناصر البيانات",
    "loyalty_request_mandatory_data_elements" to "عناصر البيانات الإلزامية",
    "movie_ticket_attribute_age_rating_code" to "رمز التصنيف العمري",
    "movie_ticket_attribute_cinema_theater" to "دار السينما",
    "movie_ticket_attribute_date_and_time_of_show" to "تاريخ ووقت العرض",
    "movie_ticket_attribute_movie_poster" to "ملصق الفيلم",
    "movie_ticket_attribute_movie_title" to "عنوان الفيلم",
    "movie_ticket_attribute_parking" to "موقف سيارات",
    "movie_ticket_attribute_seat" to "مقعد",
    "movie_ticket_attribute_theater" to "مسرح",
    "movie_ticket_attribute_ticket_number" to "رقم التذكرة",
    "movie_ticket_description_age_rating_code" to "رمز تصنيف الفيلم للقيود العمرية.",
    "movie_ticket_description_cinema_theater" to "اسم صالة السينما، و/أو عنوان/موقع الدخول.",
    "movie_ticket_description_date_and_time_of_show" to "تاريخ ووقت بدء عرض الفيلم",
    "movie_ticket_description_movie_poster" to "ملصق الفيلم",
    "movie_ticket_description_movie_title" to "اسم الفيلم، وعنوانه، وأي معلومات تعريفية أخرى للعرض.",
    "movie_ticket_description_parking" to "موقف السيارات مدفوع مسبقًا مع شراء التذكرة.",
    "movie_ticket_description_seat" to "رقم أو رمز المقعد (مثلاً: صف/مقعد).",
    "movie_ticket_description_theater" to "اسم أو رقم صالة العرض في مبنى السينما متعدد الصالات.",
    "movie_ticket_description_ticket_number" to "رقم تعريف/مرجع التذكرة الصادر عند وقت الشراء.",
    "movie_ticket_request_all_data_elements" to "جميع عناصر البيانات",
    "movie_ticket_request_prepaid_parking" to "موقف مدفوع مسبقًا",
    "movie_ticket_request_ticket_number" to "رقم التذكرة",
    "naturalization_attribute_date_of_birth" to "تاريخ الميلاد",
    "naturalization_attribute_date_of_naturalization" to "تاريخ التجنيس",
    "naturalization_attribute_family_name" to "اسم العائلة",
    "naturalization_attribute_given_names" to "الأسماء الشخصية",
    "naturalization_description_date_of_birth" to "اليوم والشهر والسنة التي ولد فيها الشخص المتجنس. إذا كان غير معروف، تاريخ ميلاد تقريبي.",
    "naturalization_description_date_of_naturalization" to "التاريخ (وربما الوقت) الذي تم فيه تجنيس الشخص.",
    "naturalization_description_family_name" to "الاسم الأخير أو العائلي، أو اللقب، أو المعرف الأساسي الحالي للشخص المتجنس",
    "naturalization_description_given_names" to "الاسم الأول الحالي (أو الأسماء الأخرى)، أو المعرف الثانوي للشخص المتجنس",
    "naturalization_request_all_data_elements" to "جميع عناصر البيانات",
    "payment_attribute_expiry_date" to "تاريخ انتهاء الصلاحية",
    "payment_attribute_holder_name" to "اسم صاحب البطاقة",
    "payment_attribute_issue_date" to "تاريخ الإصدار",
    "payment_attribute_issuer_name" to "اسم جهة الإصدار",
    "payment_attribute_masked_account_reference" to "مرجع الحساب المقنّع",
    "payment_attribute_payment_instrument_id" to "معرف أداة الدفع",
    "payment_description_expiry_date" to "تاريخ انتهاء صلاحية وثيقة الاعتماد هذه.",
    "payment_description_holder_name" to "اسم صاحب حساب الدفع.",
    "payment_description_issue_date" to "تاريخ إصدار وثيقة الاعتماد هذه.",
    "payment_description_issuer_name" to "اسم جهة الإصدار المقروء للبشر.",
    "payment_description_masked_account_reference" to "مرجع الحساب المخفي، على سبيل المثال آخر 4 أرقام من PAN.",
    "payment_description_payment_instrument_id" to "مُعرّف أداة الدفع الرمزية.",
    "payment_request_payment_sca_all" to "مصادقة قوية للعميل (SCA) للمدفوعات (جميع عناصر البيانات)",
    "payment_request_payment_sca_minimal" to "مصادقة قوية للعميل (SCA) للمدفوعات (بحد أدنى)",
    "payment_request_payment_sca_transaction" to "SCA للدفع مع معاملة دفع"
)
